import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'

import App from './App.vue'
import router from './router'

import './api/interceptors'

declare const Beacon: {
  init: (opts: { dsn: string; environment?: string }) => void
  install: (app: ReturnType<typeof createApp>) => void
}

const app = createApp(App)

app.use(createPinia())
app.use(router)

if (import.meta.env.DEV && typeof Beacon !== 'undefined') {
  Beacon.init({
    dsn: 'https://pub_wWx6I7c1P0GiunrlBwOcyC0fA4NI9sGA@api.beaconhq.test/019e32b4-4e72-72ac-98c1-757366872db7',
    environment: import.meta.env.MODE,
  })
  Beacon.install(app)
}

app.mount('#app')
